<template>
  <div class="header-container">
    
    <span
      class="menu-toggle"
      :class="`i-menu-${minimized ? 'collapsed' : 'expanded'}`"
      @click="$emit('update:minimized', !minimized)"
    />

    <img
      src="@/assets/images/NuevoLogoIbero.png"
      class="custom-logo"
      alt="Corporación Universitaria Iberoamericana Empleados"
    />

  </div>
</template>

<script>
export default {
  name: 'header-selector',
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.header-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.menu-toggle {
  cursor: pointer;
}

.custom-logo {
  width: 180px;
  height: 40px;
}
</style>
